import './PageWrapperSidebarItem.css';
import { PropsIcon } from './PageWrapperSidebarItemLink';

interface Props {
  title: string;
  isShortSideBar: boolean;
  onClick: () => void;
  Icon: React.FC<PropsIcon>;
}

export const PageWrapperSidebarItemButton: React.FC<Props> = ({
  title,
  onClick,
  Icon,
  isShortSideBar
}) => {
  return (
    <ul className="nav flex-column logout-sidebar">
      <li className="nav-item">
        <button
          className="nav-link d-flex align-items-center gap-2 button"
          onClick={onClick}
        >
          <Icon className="icon" />
          {!isShortSideBar && title}
        </button>
      </li>
    </ul>
  );
};
